export const LANGUAGES: string[] = ['en', 'vi'];
